import { ProjectModel } from "./Project.model";

export class Project extends ProjectModel {
    // Add custom methods here
}
